import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const footerColumnTwo = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Footer Column 2" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default footerColumnTwo
